let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5BMnr")).then(() => parcelRequire('6uENn'));